import React from 'react';
import { makeStyles, Card, CardContent, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    padding: theme.spacing(4, 1, 4, 4),
  },
  icon: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  row: {
    display: 'flex',
    padding: theme.spacing(4, 0, 0, 0),
    alignItems: 'center',
  },
  awardTitle: {
    fontSize: 15,
    color: theme.palette.neutrals.low.medium,
    fontWeight: 600,
  },
  awardDescription: {
    fontSize: 13,
    color: theme.palette.neutrals.low.light,
  },
  scroll: {
    height: '100%',
    maxHeight: 426,
    overflowY: 'auto',
  },
}));

function ChallengeInfoAwardsCard({ challenge }) {
  const classes = useStyles();
  const { rewards } = challenge;
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <div className={classes.content}>
          <div className={classes.header}>
            <div style={{ fontSize: 14, fontWeight: 'bold', color: theme.palette.neutrals.low.medium }}>
              {t('premiacao').toUpperCase()}
            </div>
          </div>
          <div className={classes.scroll}>
            <div>
              {rewards &&
                rewards.length > 0 &&
                rewards.map((award, index) => (
                  <div className={classes.row} key={index}>
                    <div
                      className={classes.icon}
                      style={
                        index < 3
                          ? { backgroundColor: theme.palette.auxiliary.yellow.main }
                          : { backgroundColor: theme.palette.neutrals.high.medium }
                      }
                    >
                      <span
                        className="material-icons"
                        style={{
                          color: 'white',
                          width: 30,
                          textAlign: 'center',
                        }}
                      >
                        military_tech
                      </span>
                    </div>
                    <div>
                      <div className={classes.awardTitle}>
                        {index + 1}° {t('lugar')}
                      </div>
                      <div className={classes.awardDescription}>
                        {award.description}
                        {award.score && award.score > 0 && (
                          <span>
                            + {award.score} {t('pontos').toLowerCase()}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export { ChallengeInfoAwardsCard };
